import { Button, ChoiceList, FormLayout, Popover } from '@shopify/polaris'

import { useToggle } from './helpers'

export type TableColumnChoices = { label: string; value: string; disabled?: boolean }

export interface TableSortOption {
  value: string
  label: string
}

export const TableSortBySelector = ({
  sortBy,
  onChange,
  choices,
}: {
  sortBy: string
  onChange: (sortBy: string) => any
  choices: TableSortOption[]
}) => {
  const [active, toggleActive] = useToggle(false)

  const handleChange = (selected: string[]) => {
    onChange(selected[0])
    toggleActive()
  }

  return (
    <Popover
      active={active}
      activator={
        <Button onClick={toggleActive} disclosure size="large">
          Sort by: {choices.find((c) => c.value === sortBy)?.label ?? ''}
        </Button>
      }
      autofocusTarget="first-node"
      onClose={toggleActive}
      sectioned
    >
      <FormLayout>
        <ChoiceList
          title="Columns"
          titleHidden={true}
          choices={choices}
          selected={[sortBy]}
          onChange={handleChange}
        />
      </FormLayout>
    </Popover>
  )
}
